<template>
  <div>
    <navbar></navbar>
    <div style="margin: 70px 30px 30px 60px">
      <div class="row w-100 ml-0 mr-0">
        <div class="sellProRataTitle d-flex">
          <div style="cursor: pointer" @click="goBack()">
            <i class="fas fa-arrow-left user-font mr-2 material-icon-font"></i>
          </div>
          <div class="my-auto">Buy Positions</div>
        </div>
      </div>
      <div class="row w-100 ml-0 mr-0" style="margin-top: 30px">
        <div id="theMainTableSummary" class="w-100">
          <div
            class="tabulator lp-tabulator-cls"
            ref="buyProRataRefTable"
            style="width: 100%; height: 100%"
          ></div>
        </div>
      </div>
    </div>
    <el-dialog
      left
      width="410px"
      title="One more step"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      @close="handleCancelConfirmation"
      :showClose="true"
      :visible.sync="showConfirmationDialog"
      class="sellProrataConfirmation"
    >
      <div style="padding: 0px 15px 0px 15px">
        <div class="row w-100 ml-0 mr-0">
          <div style="word-break: break-word; padding-bottom: 30px">
            A fifi representative will reach out via email with moredetails on
            the company.
            <br /><br />
            Your email and request is secured and will only beshared with
            qualified partners.
          </div>
        </div>
        <div class="text-right">
          <button
            type="button"
            style="height: 35px"
            class="todo-form-submit-button btn btn-primary"
            @click="handleConfirm()"
            :disabled="showSpinner"
          >
            Confirm
            <b-spinner
              v-if="showSpinner"
              style="float: right"
              small
              label="Loading..."
            ></b-spinner>
          </button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      left
      title
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="false"
      width="300px"
      style="margin: 0 auto"
      :visible.sync="showLoader"
      class="loadingModal col-lg-12 col-sm-12 col-12 col-md-12"
    >
      <div style="text-align: center">
        <div>
          <b-spinner
            style="width: 7rem; height: 7rem; color: #5445f3"
            class="mt-5"
            label="Large Spinner"
          ></b-spinner>
        </div>
        <div style="margin-top: 15px; color: #000">Loading...</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import NavbarNew from "../Layout/NavbarNew";
import api from "../../../axios_api";
import Tabulator from "tabulator-tables";
import moment from "moment";
import config from "../../../../config/settings";
import { mapGetters } from "vuex";
import { numberSorter } from "./investments";
import { Dialog, Select, Option } from "element-ui";
const DATA_STATUS_CONFIRMED = "Confirmed";
const DATA_STATUS_UNCONFIRMED = "Unconfirmed";
const DATA_STATUS_UPDATING = "Retrieving";
export default {
  name: "buyProRata",
  components: {
    [NavbarNew.name]: NavbarNew,
    [Dialog.name]: Dialog,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data() {
    return {
      showLoader: false,
      tabulator: null,
      showConfirmationDialog: false,
      showSpinner: false,
      company: {},
    };
  },
  computed: {
    ...mapGetters("user", ["currency", "firstName", "lastName"]),
    ...mapGetters("user", ["user"]),
    ...mapGetters("workspace", ["buyProRataData"]),
    ...mapGetters("workspace", ["interestedDeals"]),
    moment() {
      return moment;
    },
    tableData() {
      let self = this;
      let data = JSON.parse(JSON.stringify(self.buyProRataData));
      if (data.length == 0) {
        return [];
      }
      data.map((item, index) => {
        let dealIndex = self.interestedDeals.findIndex((itm) => {
          if (
            itm &&
            item._id == itm.dealRoomId &&
            this.$route.params.account_id == itm.account
          ) {
            return itm;
          }
        });
        if (dealIndex >= 0) {
          item.sent = true;
          item.sentdealDate = self.interestedDeals[dealIndex].created
            ? moment(self.interestedDeals[dealIndex].created).format(
                "MM/DD/YYYY"
              )
            : "";
        } else {
          item.sent = false;
        }
        item.companyLogoUrl = item.companyLogoUrl
          ? item.companyLogoUrl
          : "static/img/generic-logo.png";
        item.id = index;
        item.latestRoundDate = item.latestRoundDate
          ? moment(item.latestRoundDate).format("MM/DD/YYYY")
          : "-";
        let logoUrl = this.getImageUrl(item.companyLogoUrl);
        if (item.companyDataStatus == DATA_STATUS_CONFIRMED) {
          item.nameLogoString = `
                <div class="d-flex">
                    <img src="${logoUrl}" style="width: 35px;height: 35px;border-radius: 50%;" class="company-img"/>
                    <img src="static/img/confirmed.svg" class="company-statys-img"/>
                            <b style="margin-left: 48px;overflow:hidden;whitespace:nowrap;text-overflow:ellipsis;">${item.companyName}  </b> <a style="color: #00000080;overflow:hidden;whitespace:nowrap;text-overflow:ellipsis;">-${item.companyStatus}</a>
                </div>

            `;
        }
        if (item.companyDataStatus == DATA_STATUS_UNCONFIRMED) {
          item.nameLogoString = `
                <div class="d-flex">
                    <img src="${logoUrl}" style="width: 35px;height: 35px;border-radius: 50%;" class="company-img"/>
                    <img src="static/img/warning.svg" class="company-statys-img"/>
                            <b class="ml-5" style="overflow:hidden;whitespace:nowrap;text-overflow:ellipsis;">${item.companyName} </b> <a style="color: #00000080;overflow:hidden;whitespace:nowrap;text-overflow:ellipsis;">-${item.companyStatus}</a>
                </div>
            `;
        }
        if (item.companyDataStatus == DATA_STATUS_UPDATING) {
          item.nameLogoString = `
                <div class="d-flex">
                    <img src="${logoUrl}" style="width: 35px;height: 35px;border-radius: 50%;" class="company-img"/>
                    <img src="static/img/retrieving.svg" class="company-statys-img"/>
                            <b class="ml-5" style="overflow:hidden;whitespace:nowrap;text-overflow:ellipsis;">${item.companyName} </b> <a style="color: #00000080;overflow:hidden;whitespace:nowrap;text-overflow:ellipsis;">-${item.companyStatus}</a>
                </div>
            `;
        }
      });
      return data;
    },
    tableOptions() {
      return {
        layout: "fitColumns",
        tooltips: true,
        data: this.tableData,
        columns: this.tableColumns,
        tooltips: true,
        layoutColumnsOnNewData: true,
        index: "id",
        pagination: "local",
        paginationSize: 20,
        paginationSizeSelector: true,
        placeholder: "No records to view",
        virtualDom: false,
      };
    },
    tableColumns() {
      const self = this;
      return [
        {
          title: "Company Name",
          field: "companyName",
          sorter: "string",
          download: true,
          visible: false,
        },
        {
          title: "Company",
          field: "nameLogoString",
          sorter: function (a, b, aRow, bRow, column, dir, sorterParams) {
            let first = aRow.getData().companyName || "";
            let second = bRow.getData().companyName || "";
            return first.localeCompare(second);
          },
          responsive: 0,
          resizable: false,
          width: "260",
          download: false,
          formatter: "html",
          tooltip: function (cell) {
            let tootipData = `${cell._cell.row.data.companyName} - ${cell._cell.row.data.companyStatus}`;
            return tootipData;
          },
        },
        {
          title: "Post money valuation",
          field: "postMoney",
          sorter: numberSorter,
          resizable: false,
          formatter: "money",
          formatterParams: this.currency.format,
          responsive: 0,
          download: true,
        },
        {
          title: "Last round raised",
          field: "roundSize",
          sorter: numberSorter,
          formatter: "money",
          resizable: false,
          formatterParams: this.currency.format,
          responsive: 0,
          download: true,
        },
        {
          title: "Round Invested",
          field: "round",
          sorter: "string",
          resizable: false,
          download: true,
        },
        {
          minWidth: 100,
          resizable: false,
          headerSort: false,
          responsive: 0,
          download: false,
          tooltip: false,
          formatter: function (cell, params) {
            let data = cell.getData();
            return !data.sent
              ? `<button class="newTask" style="height: 35px">Interested?</button>`
              : `<div>Sent - ${data.sentdealDate || ""} </div>`;
          },
          cellClick: function (e, cell) {
            self.company = cell.getData();
            if (!self.company.sent) {
              self.showConfirmationDialog = true;
            }
          },
        },
      ];
    },
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getImageUrl(image) {
      if (!image) {
        return;
      }
      // image.includes(
      //  "https://res-3.cloudinary.com/crunchbase-production/image/upload"
      //) ||
      if (
        image.includes(config.CRUNCHBASE_IMAGE_URL) ||
        image.includes("https://res") ||
        image.includes("static/img/generic-logo.png")
      ) {
        return image;
      }
      let imageId = image.slice(image.lastIndexOf("t_api_images/") + 13);
      if (!imageId || imageId.length == 0) {
        return image;
      }
      return `${config.CRUNCHBASE_IMAGE_URL}/${imageId}`;
    },
    handleCancelConfirmation() {
      this.company = {};
      this.showConfirmationDialog = false;
      this.showSpinner = false;
    },
    handleConfirm() {
      this.showSpinner = true;
      const self = this;
      if (self.company && self.company.hasOwnProperty("_id")) {
        api
          .post(`interestedDeals/${self.$route.params.account_id}`, {
            encrypt: {
              data: {
                dealRoomId: self.company._id,
              },
            },
          })
          .then((data) => {
            self.$store
              .dispatch("workspace/apiFetchInterestedDeals", {
                account_id: self.$route.params.account_id,
              })
              .then((interestedData) => {
                self.$store
                  .dispatch("workspace/apiFetchBuyProRataData", {
                    account_id: self.$route.params.account_id,
                  })
                  .then((buyData) => {
                    self.tabulator.replaceData(self.tableOptions.data);
                    self.handleCancelConfirmation();
                    self.$toaster.success("Sent Successfully");
                  })
                  .catch((error) => {
                    console.log(
                      "error in getting buy prorata in posting to interested deals",
                      error
                    );
                    self.$toaster.error("Failed to send");
                  });
              })
              .catch((error) => {
                console.log(
                  "error in getting interested deals in posting to interested deals",
                  error
                );
                self.$toaster.error("Failed to send");
              });
          })
          .catch((error) => {
            console.log("error in posting to interested deals", error);
          });
      }
    },
  },
  mounted() {
    let self = this;
    const titleEl = document.querySelector("head title");
    titleEl.textContent = `Fiifi | Buy Positions`;
    if (this.$route.params.account_id) {
      self.showLoader = true;
      self.$store.dispatch("workspace/apiFetchInterestedDeals", {
        account_id: self.$route.params.account_id,
      });
      self.$store
        .dispatch("workspace/apiFetchBuyProRataData", {
          account_id: self.$route.params.account_id,
        })
        .then((data) => {
          if (self.$refs.buyProRataRefTable && self.tableOptions) {
            self.tabulator = new Tabulator(
              self.$refs.buyProRataRefTable,
              self.tableOptions
            );
            self.showLoader = false;
          }
        });
    }
  },
  watch: {
    tableOptions: {
      handler: function (newData) {
        if (this.tabulator) {
          this.tabulator.replaceData(this.tableOptions.data);
        }
      },
    },
  },
};
</script>